module.exports = __webpack_public_path__ + "src/img/warn.32e37142.svg";